import React, { useEffect, useState, } from "react";
import { Edit, } from "components/Views";
import { Loading, } from "components";
import { axios, } from "libs";
import { useParams, useNavigate, } from "react-router-dom";
import { Validation, } from "interfaces/responses";
import { Grid, NumberInput, TextInput, } from "@mantine/core";
import { useAlert, useSettings, } from "hooks";
import { resolveTheme, } from "themes/main";
import { TaskForm, } from "./index";

function EditTask() {
  const { organization_id, template_id, task_id, } = useParams();
  const [formState, setFormState] = useState<TaskForm>({
    description: "",
    sort_order: undefined,
  });
  const [loading, setLoading] = useState(false);
  const [validationRules, setValidationRules] = useState<Validation>();
  const [requiredFields, setRequiredFields] = useState<string[]>([]);
  const [validated, setValidated] = useState(false);
  const { setAlert, } = useAlert();
  const navigate = useNavigate();

  useEffect(() => {
    setLoading(true);
    axios
      .get(
        `/organizations/${organization_id}/templates/${template_id}/tasks/create`
      )
      .then((res) => {
        const validation = res.data.data.validation as Validation;
        setValidationRules(validation);
        setRequiredFields(
          Object.entries(validation.rules)
            .filter(([, value]) => value.includes("required"))
            .map(([key]) => key)
        );
      })
      .catch((err) => {
        console.error(err);
        setAlert({
          type: "danger",
          message: "Error loading task validation rules",
        });
      })
      .finally(() => {
        setLoading(false);
      });

    setLoading(true);
    axios
      .get(
        `/organizations/${organization_id}/templates/${template_id}/tasks/${task_id}`
      )
      .then((res) => {
        setFormState(res.data.data);
      })
      .catch((err) => {
        console.error(err);
        setAlert({
          type: "danger",
          message: "Error loading task",
        });
      })
      .finally(() => {
        setLoading(false);
      });
  }, []);

  const submitTask = () => {
    setLoading(true);
    axios
      .put(
        `/organizations/${organization_id}/templates/${template_id}/tasks/${task_id}`,
        formState
      )
      .then(() => {
        setAlert({
          type: "success",
          message: "Task updated successfully",
        });
        setLoading(false);
        navigate(
          `/organizations/${organization_id}/templates/${template_id}`
        );
      })
      .catch((err) => {
        console.error(err);
        setAlert({
          type: "danger",
          message: "Error updating task",
        });
        setLoading(false);
      });
  };

  const { theme: { current, }, } = useSettings();
  const currentTheme = resolveTheme(current);
  const { colors, } = currentTheme;

  if (loading) {
    return <Loading />;
  }

  return (
    <div>
      <Edit
        title="Edit Task"
        buttons={[
          {
            text: "Submit",
            handleClick: () => {
              submitTask();
            },
            variant: "filled",
            color: colors.primary,
            disabled: !validated,
          }
        ]}
        formState={formState}
        requiredFields={requiredFields}
        setValidated={setValidated}
      >
        <Grid>
          <Grid.Col sm={12} md={12}>
            <TextInput
              label="Description"
              name="description"
              onChange={(e) => {
                setFormState({
                  ...formState,
                  description: e.currentTarget.value,
                });
              }}
              required={validationRules?.rules?.description?.includes(
                "required"
              )}
              value={formState.description}
            />
          </Grid.Col>
          <Grid.Col sm={12} md={6}>
            <NumberInput
              label="Sort Order"
              name="sort_order"
              onChange={(e) => {
                if (!e) return;
                setFormState({
                  ...formState,
                  sort_order: e,
                });
              }}
              required={validationRules?.rules?.sort_order?.includes(
                "required"
              )}
              value={formState.sort_order}
              min={0}
              step={1}
            />
          </Grid.Col>
        </Grid>
      </Edit>
    </div>
  );
}

export default EditTask;
